import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/element-theme.css'
import qs from 'qs'
import http from './utils/axios'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(ElementUI)
Vue.use(VueQuillEditor)
Vue.config.productionTip = false

// 全局注册axios
Vue.prototype.$http = http
// 全局注册qs
Vue.prototype.$qs = qs

// 全局时间格式化过滤器
Vue.filter('formatDate', function(value) {
  if (!value) return '-';
  
  const date = new Date(value);
  
  // 检查是否为有效日期
  if (isNaN(date.getTime())) return value;
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  // 如果时分秒都是0，只返回日期部分
  if (hours === '00' && minutes === '00' && seconds === '00') {
    return `${year}-${month}-${day}`;
  }
  
  // 否则返回完整的日期时间
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
